<template>
  <div class="group-card-wrapper">
    <div class="card hoverable group-card">
      <div class="card-content">
        <h3 class="group-title">{{ group.GroupName }}</h3>
        <div class="group-desc">{{ group.GroupDescription }}</div>
        <div class="card-action">
          <router-link
            :to="`/article/${group.GroupID}`"
            class="btn blue white-text view-articles-btn"
          >
            <span class="btn-text">View Articles</span>
            <i class="material-icons btn-icon">arrow_forward</i>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupCard",
  props: {
    group: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.group-card-wrapper {
  height: 100%;
}

.group-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  margin-bottom: 24px;
  overflow: hidden;
  height: 100%;
}

.group-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.group-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #00205b;
  margin: 0 0 10px 0;
}

.group-desc {
  color: #555;
  margin-bottom: 20px;
  font-size: 0.95rem;
  line-height: 1.5;
  min-height: 60px;
}

.card .card-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card-action {
  padding-top: 15px;
  border-top: 1px solid #eaeaea;
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
}

.card .card-action {
  padding: 10px 0px;
}

.card-action .btn {
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  padding: 8px 16px;
  font-weight: 500;
  letter-spacing: 0.5px;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: #1565c0 !important;
}

.card-action .btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  background-color: #1976D2 !important;
}

.view-articles-btn .btn-icon {
  font-size: 18px;
  transition: transform 0.3s ease;
}

.view-articles-btn:hover .btn-icon {
  transform: translateX(4px);
}

.card-action .btn:before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg, 
    transparent, 
    rgba(255, 255, 255, 0.4), 
    transparent
  );
  transition: all 0.6s ease;
  z-index: 1;
}

.card-action .btn:hover:before {
  left: 100%;
  animation: shimmer 1.5s infinite;
}

.btn-text, .btn-icon {
  position: relative;
  z-index: 2;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GroupCard.vue